import { createContext } from 'react';

export const SidePanelSurfaceContext = createContext(false);
